// MEDIA_API_BASE_URL=https://mediasapi.jlb.ninja/api
export const MEDIA_API_BASE_URL = 'https://media-api.deljdlx.fr/api';
